/**
 *  INIT HEADER
 */

import user from './header/user';
import flashbags from './header/flashbags';
import modalUser from './user/modals/modal-user';

export default function () {
  if (document.querySelector('#flashbags')) {
    flashbags();
  }

  user();

  if (document.querySelector('#search-app') && document.querySelector('.modal-user')) {
    modalUser('.modal-user');
  }
}
